export enum DocAccess{
	READ_ONLY = 'READ_ONLY',
	WRITE = 'WRITE',
	FULL = 'FULL',
}
